import { render, staticRenderFns } from "./FlexGalleryLocal.vue?vue&type=template&id=13dfdb7e&scoped=true"
import script from "./FlexGalleryLocal.vue?vue&type=script&lang=js"
export * from "./FlexGalleryLocal.vue?vue&type=script&lang=js"
import style0 from "./FlexGalleryLocal.vue?vue&type=style&index=0&id=13dfdb7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dfdb7e",
  null
  
)

export default component.exports